import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/DigitalAssetsConfiguration";

export const getOnlineDirectoriesConfig = async () => {
  return axios.get(`${api_base_url}/OnlineDirectories`).then((res) => {
    return res;
  });
};

export const addOnlineDirectories = async (newOnlineDirectories) => {
  const { data } = await axios.post(`${api_base_url}/AddOnlineDirectory`, {
    ...newOnlineDirectories,
  });
  return data;
};

export const deleteOnlineDirectories = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateOnlineDirectories`, {
    data: ids,
  });

  return data;
};

export const updateOnlineDirectories = async (editOnlineDirectoriesData) => {
  const { data } = await axios.put(`${api_base_url}/UpdateOnlineDirectories`, editOnlineDirectoriesData);
  return data;
};
